import React from "react";
import { Grid, Typography, CircularProgress } from "@mui/material";
import { StyledPayButton } from "../../utilities/styles/checkoutPage.style";
import SkipifyIntegration from "../../components/SkipifyIntegration";
import { formatMoney } from "../../pipes/PriceFormatter";

interface PaymentSectionProps {
    organizationSettings: any;
    isKitchenClosed: boolean;
    isOrderEmpty: boolean;
    creatingOrder: boolean;
    creatingOrderWithSkipify: boolean;
    onHoverSkipifyButton?: any;
    isDisabled: boolean; 
    email?: string;
    phoneNumber?: string;
    skipifyGuid: string;
    total: number;
    isPayLaterDisabled?: boolean;
    onPayNow?: any;
    onPayLater?: any;
    onSkipifyClick?: any;
    onSkipifySuccess?: (response: any) => any;
    onSkipifyClose?: any;
}

const PaymentSection: React.FC<PaymentSectionProps> = ({
    organizationSettings,
    isKitchenClosed,
    isOrderEmpty,
    creatingOrder,
    creatingOrderWithSkipify,
    onHoverSkipifyButton,
    isDisabled,
    email,
    phoneNumber,
    skipifyGuid,
    total,
    isPayLaterDisabled,
    onPayNow,
    onPayLater,
    onSkipifyClick,
    onSkipifySuccess,
    onSkipifyClose,
}) => {
    return (
        <>
            {!isOrderEmpty && (
                <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
                    {!organizationSettings?.useSkipify ? (
                        <>
                            {organizationSettings?.enablePayNow && (
                                <Grid item={true} xs={12} sm={12}>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "8px",
                                        }}
                                    >
                                        <StyledPayButton
                                            variant="contained"
                                            color="layoutColor"
                                            disableElevation
                                            disabled={isDisabled || creatingOrder}
                                            sx={{
                                                backgroundColor: organizationSettings?.layoutColor,
                                                "&.MuiButton-root:hover": {
                                                    backgroundColor: organizationSettings?.layoutColor,
                                                },
                                            }}
                                            onClick={onPayNow}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: { xs: "16px" },
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Pay Now ${formatMoney(total)}
                                            </Typography>
                                        </StyledPayButton>
                                    </div>
                                </Grid>
                            )}
                        </>
                    ) : (
                        <>
                            {creatingOrderWithSkipify ? (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <CircularProgress size={20} color="secondary" />
                                    <p
                                        style={{
                                            fontSize: 16,
                                            paddingLeft: "8px",
                                        }}
                                    >
                                        Loading Skipify
                                    </p>
                                </div>
                            ) : (
                                <>
                                    {isDisabled ? (
                                        <Grid item={true} xs={12} sm={12}>
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    margin: "8px",
                                                }}
                                            >
                                                <StyledPayButton
                                                    variant="contained"
                                                    color="layoutColor"
                                                    disableElevation
                                                    disabled
                                                    sx={{
                                                        backgroundColor: organizationSettings?.layoutColor,
                                                        "&.MuiButton-root:hover": {
                                                            backgroundColor: organizationSettings?.layoutColor,
                                                        },
                                                    }}
                                                >
                                                    {creatingOrderWithSkipify && (
                                                        <CircularProgress size={24} color="info" />
                                                    )}
                                                    <Typography
                                                        sx={{
                                                            fontSize: { xs: "16px" },
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        Pay Now
                                                    </Typography>
                                                </StyledPayButton>
                                            </div>
                                        </Grid>
                                    ) : (
                                        <div style={{ padding: "8px" }}>
                                            <SkipifyIntegration
                                                cartRefId={skipifyGuid}
                                                merchantId={organizationSettings.skipifyMerchantID}
                                                onSuccess={onSkipifySuccess}
                                                buttonColor={organizationSettings?.layoutColor}
                                                email={email}
                                                phone={phoneNumber}
                                                onClose={onSkipifyClose}
                                                onClick={onSkipifyClick}
                                                onHoverSkipifyButton={onHoverSkipifyButton}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    )}

                    {organizationSettings?.enablePayLater && (
                        <Grid item={true} xs={12} sm={12}>
                            <div
                                style={{
                                    textAlign: "center",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "8px",
                                }}
                            >
                                <StyledPayButton
                                    variant="contained"
                                    color="layoutColor"
                                    disableElevation
                                    disabled={isDisabled}
                                    sx={{
                                        backgroundColor: organizationSettings?.layoutColor,
                                        "&.MuiButton-root:hover": {
                                            backgroundColor: organizationSettings?.layoutColor,
                                        },
                                    }}
                                    onClick={onPayLater}
                                >
                                    {creatingOrder && (
                                        <CircularProgress size={24} color="info" />
                                    )}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "16px" },
                                            fontWeight: 600,
                                        }}
                                    >
                                        Pay Later
                                    </Typography>
                                </StyledPayButton>
                            </div>
                        </Grid>
                    )}
                </div>
            )}
        </>
    );
};

export default PaymentSection;
